import GenericModal from '../../../Components/GenericModal'
import { Autocomplete, Box, Stack, TextField } from '@mui/material'
import { useMutation } from 'react-query'
import { Protocol } from '../../../Typescript/StuartPy/Protocol'
import { AxiosResponse } from 'axios'
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useProtocolGet } from '../../../APIs/Hooks/ProtocolHooks'
import PyAPI from '../../../APIs/Python/APIs/PyAPI'

function CloneModal({ open, setOpen }: { open: boolean; setOpen: any }) {
  const { whoAmI } = useUserContext()
  const { study_id } = useParams()
  const protocolQuery = useProtocolGet('', open)

  const [protocol, setProtocol] = useState<Protocol | undefined>(undefined)
  const [newName, setNewName] = useState('')

  const navigate = useNavigate()

  const {
    mutate: cloneStudy,
    isLoading,
    error,
  } = useMutation<any, AxiosResponse>(
    () =>
      PyAPI.post(
        whoAmI,
        `/study/${study_id}/clone?protocol_id=${protocol!.ProtocolID}&study_name=${newName}`,
      ),
    {
      onSuccess: (data) => {
        setOpen(false)
        setNewName('')
        setProtocol(undefined)
        navigate(`../../${data?.StudyID}/configure`)
      },
    },
  )

  return (
    <GenericModal
      open={open}
      loading={isLoading}
      error={error}
      setClose={() => {
        setOpen(false)
        setNewName('')
        setProtocol(undefined)
      }}
      setCommit={
        protocol && newName.length > 0 ?
          () => {
            cloneStudy()
          }
        : undefined
      }
      title={'Clone Study'}
    >
      <Stack gap={1}>
        <TextField
          autoFocus
          fullWidth
          value={newName ?? ''}
          label="New Name"
          margin="normal"
          onChange={(e) => setNewName(e.target.value)}
        />
        <Autocomplete
          sx={{ pt: 1 }}
          fullWidth
          options={protocolQuery?.data ?? []}
          autoHighlight
          getOptionLabel={(option: any) => option.EthicsNumber}
          renderOption={(props, option) => (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option.EthicsNumber}
            </Box>
          )}
          onChange={(_: any, newValue) => {
            setProtocol(newValue)
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Choose a protocol"
              inputProps={{
                ...params.inputProps,
              }}
            />
          )}
          isOptionEqualToValue={(option, value) => {
            return option?.ProtocolID === value?.ProtocolID
          }}
          disableClearable
        />
      </Stack>
    </GenericModal>
  )
}

export default CloneModal
